// new environment
export const appConfig = {
  // todo add library to handle env variables
  // DotNet_Api_Endpoint: 'https://localhost:7244/api/v1',
    // DotNet_Api_Endpoint: 'https://localhost:5288/api',
  // DotNet_Api_Endpoint: 'https://api-aca-testlegacy.azurewebsites.net/api/v1',
  // Set at build time by scripts/deploy.sh (REACT_APP_API_ENDPOINT); the literal below is
  // the TEST API so `npm start` and a plain `npm run build` keep working unchanged.
  DotNet_Api_Endpoint:
    process.env.REACT_APP_API_ENDPOINT || 'https://api-aca-prodv2.azurewebsites.net/api',
  // DotNet_Api_Endpoint: 'https://api-aca-prodv2.azurewebsites.net/api',
  // imgUrl:
  //   'https://alhilalacademy-data.s3.eu-north-1.amazonaws.com/hq-images/images/',
  imgUrl:
    'https://staca01prod.blob.core.windows.net/ahl/hq-images/images/',
  defaultTimeout: 5000,
};
